import { resource, tapState, tapEffect, tapCallback } from "@assistant-ui/tap";
import { tapAssistantClientRef, attachDefaultPeers, } from "@assistant-ui/store";
import { ModelContext } from "./ModelContextClient.js";
export const Tools = resource(({ toolkit }) => {
    const [state, setState] = tapState(() => ({
        tools: {},
    }));
    const clientRef = tapAssistantClientRef();
    const setToolUI = tapCallback((toolName, render) => {
        setState((prev) => {
            return {
                ...prev,
                tools: {
                    ...prev.tools,
                    [toolName]: [...(prev.tools[toolName] ?? []), render],
                },
            };
        });
        return () => {
            setState((prev) => {
                return {
                    ...prev,
                    tools: {
                        ...prev.tools,
                        [toolName]: prev.tools[toolName]?.filter((r) => r !== render) ?? [],
                    },
                };
            });
        };
    }, []);
    tapEffect(() => {
        if (!toolkit)
            return;
        const unsubscribes = [];
        // Register tool UIs (exclude symbols)
        for (const [toolName, tool] of Object.entries(toolkit)) {
            if (tool.render) {
                unsubscribes.push(setToolUI(toolName, tool.render));
            }
        }
        // Register tools with model context (exclude symbols)
        const toolsWithoutRender = Object.entries(toolkit).reduce((acc, [name, tool]) => {
            const { render, ...rest } = tool;
            acc[name] = rest;
            return acc;
        }, {});
        const modelContextProvider = {
            getModelContext: () => ({
                tools: toolsWithoutRender,
            }),
        };
        unsubscribes.push(clientRef.current.modelContext().register(modelContextProvider));
        return () => {
            unsubscribes.forEach((fn) => fn());
        };
    }, [toolkit, setToolUI, clientRef]);
    return {
        state,
        methods: {
            getState: () => state,
            setToolUI,
        },
    };
});
attachDefaultPeers(Tools, {
    modelContext: ModelContext(),
});
//# sourceMappingURL=Tools.js.map